import { Redirect } from 'react-router-dom';

const PageNotFound = () => {
  return <Redirect to="/dashboard" />;
};

export default PageNotFound;
